import React from "react";

const T22 = ({
  color = "red",
  width = 80,
  height = 80,
  isCompleted,
  filling,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 101 326"
      fill="none"
    >
      <path
        d="M31.4001 207.7C50.6001 191.6 83.8001 196.2 94.8001 232C96.0001 216 97.6001 193.9 96.8001 176.1C95.5001 148.4 92.0001 135.7 83.0001 91.2C77.0001 60.2 89.7001 32.7 94.2001 18.5C98.7001 4.30005 90.5001 -0.199951 85.8001 2.40005C81.1001 5.00005 49.3001 29.5 35.7001 72.3C23.4001 111 19.1001 171.7 14.1001 231.2C18.3001 221.9 23.9001 214 31.4001 207.7Z"
        fill={`${
          filling?.fullTooth || filling?.crownFilling
            ? color
            : "url(#paint0_linear_1055_766)"
        }`}
      />
      <path
        d="M96.3001 237.8C95.9001 235.8 95.3001 233.9 94.8001 232C83.8001 196.2 50.6001 191.5 31.4001 207.7C23.9001 214 18.3001 221.9 14.1001 231.2C7.00013 246.9 3.80013 266.7 1.80013 290C-1.39987 327.2 16.6001 324.6 29.7001 324C36.8001 323.6 61.3001 322.1 78.1001 314.1C94.8001 306.1 105.3 278.8 96.3001 237.8Z"
        fill={`${
          filling?.fullTooth || filling?.rootFilling
            ? color
            : "url(#paint1_linear_1055_766)"
        }`}
      />
      <path
        d="M96.8001 176.1L97.7991 176.055L97.799 176.053L96.8001 176.1ZM83.0001 91.2L82.0183 91.3901L82.02 91.3983L83.0001 91.2ZM35.7001 72.3L36.6532 72.603L36.6532 72.6029L35.7001 72.3ZM14.1001 231.2L15.0113 231.612L15.0115 231.612L14.1001 231.2ZM96.3001 237.8L95.3195 237.996C95.3208 238.002 95.322 238.008 95.3234 238.014L96.3001 237.8ZM1.80013 290L2.79645 290.086L2.79647 290.086L1.80013 290ZM29.7001 324L29.7459 324.999L29.7564 324.998L29.7001 324ZM78.1001 314.1L78.5301 315.003L78.5322 315.002L78.1001 314.1ZM31.4001 207.7L32.0427 208.466C41.392 200.626 54.1446 197.832 65.8885 201.346C77.603 204.85 88.4293 214.67 93.8442 232.294L94.8001 232L95.756 231.706C90.171 213.53 78.8973 203.15 66.4617 199.43C54.0557 195.718 40.6082 198.674 30.7576 206.934L31.4001 207.7ZM94.8001 232L95.7973 232.075C96.9964 216.087 98.6023 193.926 97.7991 176.055L96.8001 176.1L95.8011 176.145C96.598 193.874 95.0039 215.913 93.8029 231.925L94.8001 232ZM96.8001 176.1L97.799 176.053C96.4945 148.256 92.9718 135.46 83.9803 91.0018L83.0001 91.2L82.02 91.3983C91.0284 135.94 94.5058 148.544 95.8012 176.147L96.8001 176.1ZM83.0001 91.2L83.9819 91.01C78.0435 60.3284 90.6056 33.153 95.1534 18.8021L94.2001 18.5L93.2468 18.198C88.7946 32.2471 75.9567 60.0716 82.0183 91.3901L83.0001 91.2ZM94.2001 18.5L95.1534 18.8021C97.4559 11.5364 96.5984 6.46323 94.2288 3.52259C91.8579 0.58044 88.1037 -0.0170581 85.3161 1.52502L85.8001 2.40005L86.2842 3.27508C88.1966 2.21716 90.8923 2.56966 92.6715 4.77751C94.4518 6.98686 95.4443 11.2637 93.2468 18.198L94.2001 18.5ZM85.8001 2.40005L85.3161 1.52502C82.829 2.90083 73.6157 9.76676 63.3323 21.6197C53.0294 33.4951 41.5981 50.4368 34.7471 71.9972L35.7001 72.3L36.6532 72.6029C43.4022 51.3633 54.6709 34.655 64.843 22.9304C75.0345 11.1833 84.0712 4.49927 86.2842 3.27508L85.8001 2.40005ZM35.7001 72.3L34.7471 71.9971C22.4038 110.834 18.098 171.683 13.1036 231.116L14.1001 231.2L15.0966 231.284C20.1022 171.717 24.3965 111.167 36.6532 72.603L35.7001 72.3ZM14.1001 231.2L15.0115 231.612C19.1603 222.425 24.6763 214.654 32.0433 208.466L31.4001 207.7L30.7569 206.934C23.124 213.346 17.4399 221.375 13.1888 230.788L14.1001 231.2ZM96.3001 237.8L97.2807 237.604C96.8732 235.566 96.2505 233.582 95.7672 231.746L94.8001 232L93.8331 232.255C94.3497 234.218 94.927 236.034 95.3195 237.996L96.3001 237.8ZM94.8001 232L95.756 231.706C90.1712 213.53 78.8981 203.126 66.4627 199.392C54.0557 195.668 40.6067 198.624 30.7553 206.936L31.4001 207.7L32.045 208.464C41.3936 200.576 54.1445 197.782 65.8876 201.308C77.6021 204.825 88.429 214.67 93.8442 232.294L94.8001 232ZM14.1001 231.2L13.189 230.788C6.01455 246.653 2.80526 266.597 0.803793 289.915L1.80013 290L2.79647 290.086C4.795 266.803 7.9857 247.148 15.0113 231.612L14.1001 231.2ZM1.80013 290L0.803808 289.914C-0.803038 308.594 2.86226 317.752 9.07301 322C12.1445 324.102 15.72 324.909 19.2916 325.169C22.848 325.428 26.5155 325.147 29.7459 324.999L29.7001 324L29.6544 323.001C26.3348 323.153 22.8397 323.422 19.4367 323.175C16.049 322.928 12.8682 322.173 10.2022 320.35C4.938 316.748 1.2033 308.606 2.79645 290.086L1.80013 290ZM29.7001 324L29.7564 324.998C36.8257 324.6 61.5245 323.101 78.5301 315.003L78.1001 314.1L77.6702 313.197C61.0757 321.099 36.7746 322.6 29.6439 323.002L29.7001 324ZM78.1001 314.1L78.5322 315.002C87.2183 310.841 94.1623 301.728 97.8013 288.592C101.442 275.448 101.803 258.203 97.2769 237.586L96.3001 237.8L95.3234 238.014C99.7977 258.397 99.4078 275.302 95.8739 288.058C92.338 300.822 85.682 309.359 77.6681 313.198L78.1001 314.1Z"
        fill={`${!isCompleted ? "#98814C" : "#FFFFFF"}`}
        strokeWidth="4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1055_766"
          x1="99.5523"
          y1="162.979"
          x2="1.3725"
          y2="162.979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B59B6F" />
          <stop offset="0.1062" stop-color="#C0AA84" />
          <stop offset="0.3663" stop-color="#D8CCB3" />
          <stop offset="0.4964" stop-color="#E1D9C5" />
          <stop offset="0.6627" stop-color="#D0C1A4" />
          <stop offset="0.8839" stop-color="#BDA67E" />
          <stop offset="1" stop-color="#B59B6F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1055_766"
          x1="99.6062"
          y1="261.524"
          x2="1.33853"
          y2="261.524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B59B6F" />
          <stop offset="0.0189621" stop-color="#C2AD89" />
          <stop offset="0.0470928" stop-color="#D3C3A8" />
          <stop offset="0.0790017" stop-color="#E0D6C4" />
          <stop offset="0.115" stop-color="#ECE5DA" />
          <stop offset="0.1571" stop-color="#F4F1EB" />
          <stop offset="0.2091" stop-color="#FBF9F6" />
          <stop offset="0.2821" stop-color="#FEFEFD" />
          <stop offset="0.4847" stop-color="white" />
          <stop offset="0.7001" stop-color="#FEFEFD" />
          <stop offset="0.7777" stop-color="#FBF9F6" />
          <stop offset="0.833" stop-color="#F4F1EB" />
          <stop offset="0.8777" stop-color="#ECE5DA" />
          <stop offset="0.916" stop-color="#E0D6C4" />
          <stop offset="0.9499" stop-color="#D3C3A8" />
          <stop offset="0.9798" stop-color="#C2AD89" />
          <stop offset="1" stop-color="#B59B6F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default T22;
